import React from "react";
import {
  Box,
  TextField,
  Typography,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Tooltip,
  Stack,
} from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import MultiTagSelector from "./MultiTagSelector";

export default function MiniGameSection({ config, onChange, tagsData }) {
  const updateTitle = (value) => {
    onChange({ ...config, title: value });
  };

  const updateSelectFilter = (filterKey, value) => {
    onChange({ ...config, [filterKey]: value });
  };

  const updateShow = (value) => {
    onChange({ ...config, show: value });
  };

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <Typography variant="subtitle2">Display</Typography>

      <Box display="flex" gap={2} alignItems="flex-end" flexWrap="wrap">
        <Box>
          <Typography
            variant="caption"
            color="text.secondary"
            display="block"
            mb={0.5}
          >
            Title
          </Typography>
          <TextField
            fullWidth
            size="small"
            placeholder="Enter title"
            value={config.title}
            onChange={(e) => updateTitle(e.target.value)}
          />
        </Box>

        <FormControl size="small" style={{ minWidth: 160 }}>
          <InputLabel>Select Filter</InputLabel>
          <Select
            value={config.rankFilter ?? ""}
            label="Select Filter"
            onChange={(e) =>
              updateSelectFilter("rankFilter", e.target.value || null)
            }
          >
            <MenuItem value="">
              <Box>
                <Typography variant="body2">None</Typography>
                <Typography variant="caption" color="text.secondary">
                  No filter applied
                </Typography>
              </Box>
            </MenuItem>
            <MenuItem value="topWeek">
              <Box>
                <Typography variant="body2">Top Week</Typography>
                <Typography variant="caption" color="text.secondary">
                  Most coins spent this week
                </Typography>
              </Box>
            </MenuItem>
            <MenuItem value="topMonth">
              <Box>
                <Typography variant="body2">Top Month</Typography>
                <Typography variant="caption" color="text.secondary">
                  Most coins spent this month
                </Typography>
              </Box>
            </MenuItem>
            <MenuItem value="topToday">
              <Box>
                <Typography variant="body2">Top Today</Typography>
                <Typography variant="caption" color="text.secondary">
                  Most coins spent today
                </Typography>
              </Box>
            </MenuItem>
            <MenuItem value="topAllTime">
              <Box>
                <Typography variant="body2">Top All Time</Typography>
                <Typography variant="caption" color="text.secondary">
                  Most coins spent ever
                </Typography>
              </Box>
            </MenuItem>
            <MenuItem value="mostPopular">
              <Box>
                <Typography variant="body2">Most Popular</Typography>
                <Typography variant="caption" color="text.secondary">
                  Most frequently played games ever
                </Typography>
              </Box>
            </MenuItem>
            <MenuItem value="new">
              <Box>
                <Typography variant="body2">New</Typography>
                <Typography variant="caption" color="text.secondary">
                  Maps to 'New' field of game provider
                </Typography>
              </Box>
            </MenuItem>
            <MenuItem value="featuredRandom">
              <Box>
                <Typography variant="body2">Featured (Random)</Typography>
                <Typography variant="caption" color="text.secondary">
                  Maps to 'Featured' field of game provider
                </Typography>
              </Box>
            </MenuItem>
            <MenuItem value="recentlyPlayed">
              <Box>
                <Typography variant="body2">Recently Played</Typography>
                <Typography variant="caption" color="text.secondary">
                  Recently played games by logged in user
                </Typography>
              </Box>
            </MenuItem>
            <MenuItem value="favourite">
              <Box>
                <Typography variant="body2">Favourites (most played)</Typography>
                <Typography variant="caption" color="text.secondary">
                  Most frequently played games by logged in user
                </Typography>
              </Box>
            </MenuItem>
          </Select>
        </FormControl>

        <Stack
          sx={{
            display: "flex",
            gap: 2,
            alignItems: "center",
            flexDirection: "row",
          }}
        >
          <Tooltip
            title="When a filter is applied, it overrides selected tags and shows only matching results."
            placement="top"
            arrow
          >
            <InfoOutlinedIcon
              fontSize="small"
              color="action"
              sx={{ cursor: "pointer", mt: "4px" }}
            />
          </Tooltip>
          <MultiTagSelector
            config={config}
            tagsData={tagsData}
            updateSelectFilter={updateSelectFilter}
          />
        </Stack>

        {/* Show Dropdown */}
        <FormControl size="small" style={{ minWidth: 80 }}>
          <InputLabel>Show</InputLabel>
          <Select
            value={config.show}
            label="Show"
            onChange={(e) => updateShow(e.target.value)}
          >
            <MenuItem value="5">5</MenuItem>
            <MenuItem value="10">10</MenuItem>
            <MenuItem value="15">15</MenuItem>
            <MenuItem value="20">20</MenuItem>
          </Select>
        </FormControl>
      </Box>
    </Box>
  );
}
